export default {
  en: {
    searchToSendTitle: 'Search Market, Agent or Email to send newsletter',
    searchByKeyword: 'Search by keyword',
    placeholder: 'Market mame, Agent type, Agent name',
    filterType: 'Filter Type',
    market: 'Market',
    agent: 'Agent',
    agentType: 'Agent Type',
    type: 'Type',
    name: 'Name',
    save: 'Save',
    added: 'Added',
    add: 'Add',
    cancel: 'Cancel'
  },
  th: {
    searchToSendTitle: 'ค้นหาตลาด, ตัวแทน หรืออีเมล เพื่อส่งจดหมายข่าว',
    searchByKeyword: 'ค้นหาโดยคีย์เวิร์ด',
    placeholder: 'ชื่อตลาด, ประเภทตัวแทน, ชื่อตัวแทน',
    filterType: 'ประเภทการค้นหา',
    market: 'ตลาด',
    agent: 'ตัวแทน',
    agentType: 'ประเภทตัวแทน',
    type: 'ประเภท',
    name: 'ชื่อ',
    save: 'บันทึก',
    added: 'เพิ่มแล้ว',
    add: 'เพิ่ม',
    cancel: 'ยกเลิก'
  }
}
